import { render, staticRenderFns } from "./warmTips.vue?vue&type=template&id=5d59cfc1&scoped=true"
import script from "./warmTips.vue?vue&type=script&lang=js"
export * from "./warmTips.vue?vue&type=script&lang=js"
import style0 from "./warmTips.vue?vue&type=style&index=0&id=5d59cfc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d59cfc1",
  null
  
)

export default component.exports